import { Injectable } from '@angular/core';
import {CourseModel, StudentCourseDetails, StudentCourseModel} from '../models';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { Status } from 'src/app/@core/enums/status.enum';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { UpdateAssignStatus } from '../models/update-assign-status.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import {Observable} from "rxjs";
import {ResponseResult} from "../../@core/models/response.model";
import { CourseFilter } from 'src/app/home/models/course-filter.model';

@Injectable({
  providedIn: 'root',
})
export class StudentCourseService extends BaseFucntionsService<CourseModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.TraineeCourse.Controller, apiClient);
  }

  getPagingAuth(data: FilterModel, additionalQuery?: string): any {
    if (data?.sortField) {
      data.sortField =
        data.sortField.charAt(0).toUpperCase() + data.sortField.slice(1);
    }

    return this.apiClient.get(
      `${ApplicationRoutes.TraineeCourse.TraineeCoursesDetails}?${this.getQueryString(data) + additionalQuery}`
    );
  }

  courseStudents(courseId: number, filter: FilterModel) {
    return this.apiClient.get(`${ApplicationRoutes.TraineeCourse.CourseTrainees(courseId)}?${this.getQueryString(filter)}`);
  }

  checkIfAssigned(courseId: number) {
    return this.apiClient.get(`${ApplicationRoutes.TraineeCourse.TraineeEnrolledCourse(courseId)}`);
  }


  checkCanJoin(courseId: number) {
    return this.apiClient.get(`${ApplicationRoutes.TraineeCourse.RemainingSeats(courseId)}`);
  }

  assignStudent(model: StudentCourseModel){
    return this.apiClient.create(`${ApplicationRoutes.TraineeCourse.CourseEnrollment(model.courseId)}`, model);
  }

  getRequiredLearningPathPreCourses(courseId: number){
    return this.apiClient.get(`${ApplicationRoutes.TraineeCourse.PreLearningPathCourses(courseId)}`);
  }
  
  myCourses(filter: FilterModel, queryString: string){
    return this.apiClient.get(`${ApplicationRoutes.TraineeCourse.TraineeCoursesProfile}?${this.joinQuery(this.getQueryString(filter), queryString)}`);
  }

  getCustomPaging(data: CourseFilter, additionalQuery?: string): any {
    if (data?.sortField) {
      data.sortField = data.sortField.charAt(0).toUpperCase() + data.sortField.slice(1);
    }

    return this.apiClient.get(`${this.urlPrefix}?${this.joinQuery(this.getQueryString(data), additionalQuery)}`);
  }

  getPendingCourses() {
    return this.apiClient.get(`${ApplicationRoutes.TraineeCourse.TraineePendingCourses}`);
  }

  changeAssignStatus(data: UpdateAssignStatus) {
    return this.apiClient.update(`${ApplicationRoutes.TraineeCourse.ChangeTraineeCourseAssignState(data.courseId)}`, data);
  }

  getStudentStatistics() {
    return this.apiClient.get(`${ApplicationRoutes.TraineeCourse.TraineeCount}`);
  }
}
